import React from 'react'
import MobileIconUi from './ui/MobileIconUi'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { RangeElement } from 'src/editor/shared/ui-lib/range-element'

type LetterSpacingProps = {
  letterSpacing?: number
  change: (val: number) => void
}

function LetterSpacing({ letterSpacing = 0, change }: LetterSpacingProps) {
  const { isMobile } = useDeviceModeContext()
  return (
    <RangeElement
      labelIcon={isMobile ? <MobileIconUi /> : null}
      label="settings_styles.letter_spacing.label"
      value={letterSpacing}
      max={10}
      onChange={change}
      allowNegative
      isDecimalAllowed
    />
  )
}

export default LetterSpacing
